export const adminRouteEntries = {
  dashboard: () => import('./presentation/dashboard/DashboardPage'),
  admin: () => import('./presentation/admin/AdminPage'),
  notificationBell: () => import('./presentation/notifications/NotificationBell'),
} as const;